import * as React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

// Dependency-free checkbox with the same look as the original shadcn/Radix one.
// (Radix Checkbox caused an infinite render loop under React 19 when used in
// the service chips, which crashed the page.)
//  - decorative: renders only the visual box (used inside the service chips)
//  - otherwise: a real <input type="checkbox"> layered under the visual box
const Checkbox = ({ checked = false, onCheckedChange, className, decorative = false, ...props }) => {
  const state = checked ? "checked" : "unchecked";
  const box = cn(
    "h-4 w-4 shrink-0 rounded-sm border border-primary shadow flex items-center justify-center data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
    className
  );
  const mark = checked ? <Check className="h-4 w-4" /> : null;

  if (decorative) {
    return (
      <span aria-hidden="true" data-state={state} className={box}>
        {mark}
      </span>
    );
  }

  return (
    <span className="relative inline-flex shrink-0">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onCheckedChange?.(e.target.checked)}
        className="peer absolute inset-0 m-0 h-full w-full cursor-pointer opacity-0"
        {...props}
      />
      <span aria-hidden="true" data-state={state} className={cn(box, "peer-focus-visible:ring-2 peer-focus-visible:ring-ring")}>
        {mark}
      </span>
    </span>
  );
};

export { Checkbox };
